import React from 'react';
import './Input.css';

export function Input({ className = '', ...props }) {
  return <input className={`cw-input${className ? ` ${className}` : ''}`} {...props} />;
}

export function Select({ className = '', children, ...props }) {
  return (
    <select className={`cw-input cw-select${className ? ` ${className}` : ''}`} {...props}>
      {children}
    </select>
  );
}

export default Input;
